import { render } from "./LoadingModal.vue?vue&type=template&id=f6b5f326"
import script from "./LoadingModal.vue?vue&type=script&lang=js"
export * from "./LoadingModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rapid-rent/bissel-service-calls/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__